// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.schedule.scheduleitem.SearchAppointmentSlotRequest */
/* istanbul ignore next */
@GandalfModel
export class SearchAppointmentSlotRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	employeeId!: number | null;

	@GandalfValidator({ notNull: { message: 'Type is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	encounterTemplateId!: number;

	@GandalfValidator({ notNull: { message: 'Appointment End Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	fridayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfProperty({ designType: Number })
	locationId!: number | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	mondayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfProperty({ designType: Number })
	roleId!: number | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	saturdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfValidator({ notNull: { message: 'Appointment Start Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	startDate!: Date;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	sundayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	thursdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	tuesdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

	@GandalfConstantDecorator(constants.SchedulingPreferencesTimeOfDay)
	@GandalfProperty({ designType: constants.SchedulingPreferencesTimeOfDay })
	wednesdayTime!: constants.SchedulingPreferencesTimeOfDay | null;

}
